import React from 'react'

export const MailSvg = ({ width = '24', height = '16', fill = '#43927C' }) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox='0 0 16 16' fill='none'>
      <g clipPath='url(#clip0_36611_46686)'>
        <path
          d='M14.6535 4.66211L8.66483 8.47671C8.4616 8.59474 8.23077 8.65692 7.99576 8.65692C7.76074 8.65692 7.52991 8.59474 7.32669 8.47671L1.33203 4.66211'
          stroke='#43927C'
          strokeWidth='1.33215'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M13.3213 2.66406H2.66418C1.92845 2.66406 1.33203 3.26048 1.33203 3.99621V11.9891C1.33203 12.7248 1.92845 13.3212 2.66418 13.3212H13.3213C14.0571 13.3212 14.6535 12.7248 14.6535 11.9891V3.99621C14.6535 3.26048 14.0571 2.66406 13.3213 2.66406Z'
          stroke='#43927C'
          strokeWidth='1.33215'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_36611_46686'>
          <rect width='15.9857' height='15.9857' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
